import ChatsService from '@/services/chatsService'

export default {
  state: {
    hasUnread: false,
    unreadByType: { direct: false, group: false, archived: false },
  },
  mutations: {
    SET_CHAT_UNREAD_STATUS(state, { has_unread, by_type }) {
      state.hasUnread = has_unread
      state.unreadByType = {
        direct: !!by_type?.direct,
        group: !!by_type?.group,
        archived: !!by_type?.archived,
      }
    },
  },
  actions: {
    async FETCH_CHAT_UNREAD_STATUS({ commit }) {
      try {
        const { data } = await ChatsService.getHasUnread()
        commit('SET_CHAT_UNREAD_STATUS', data)
      } catch (e) {
        // ignore network errors
      }
    },
  },
  getters: {
    GET_CHAT_HAS_UNREAD: (state) => state.hasUnread,
    GET_CHAT_UNREAD_BY_TYPE: (state) => state.unreadByType,
  },
}
